/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect, useRef} from "react";
// import {Table} from "react-bootstrap";
import {Row, Container, Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import Line from "./Charts/Line";
import Bar from "./Charts/Bar";
import {useSelector, useDispatch} from "react-redux";
import {Modal, Table} from "react-bootstrap";
import CardsHistory from "./CardsHistory";

import Moment from 'react-moment';
import { resetRightInformation } from "../actions/proyects.actions";
import { resetRightInformationGraphic } from "../actions/proyects.actions";
import { KeyboardDatePicker } from "@material-ui/pickers";
import {SelectedDateFn} from '../actions/auth.action';
import moment from 'moment';
import { DateLocal } from './../actions/helper';


const ControlParty = ({
	cardInformationRedux,
	graphicLinesRedux,
	graphicBarRedux,
	graphicLinesWithHeadRedux,
	graphicBarWithHeadRedux,
	tableDetailsRedux,
	tableMeansRedux,
	onClickGraphicBar,
	onClickGraphicLines,

	codProyect,
	codClassification,
	onSelectTableTitle,
	codType,
	codMeans,
	// selectedDate,
	onChangeTitle,
	cardTitle,
	changeDate = false,
	handleLoading,
}) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	// const auth = useSelector(state => state.auth);
	let dateProject = localStorage.getItem('date-project') || Date.now();
	const [dataCard, setDataCard] = useState({});
	const [loading, setLoading] = useState(true);
	const [lgShow, setLgShow] = useState(false);
	const [tableHead, setTableHead] = useState("");
	const [lines, setLines] = useState(true);
	const [openCalendar, setOpenCalendar] = useState(false);
	const [selectedDate, setSelectedDate] = useState();

	const tableHeadRef = useRef();
	const linesRef = useRef();
	// update ref
	useEffect(() => {tableHeadRef.current = tableHead;}, [tableHead]);
	useEffect(() => {linesRef.current = lines;}, [lines]);

	const handleDateChange = (v1, date) => {
		console.log(v1);
		console.log(date)
		// dispatch(resetRightInformation());
		setSelectedDate(moment(date).format('yyyy/MM'));
		dispatch(SelectedDateFn(moment(date).format('yyyy/MM')));
		localStorage.setItem('date-project', moment(date).format('yyyy/MM'));
	}

	useEffect(() => {
		if(handleLoading) handleLoading(loading);
	}, [loading]);

	useEffect(() => {
		const mydate = async () => {
			const myDate = await localStorage.getItem('date-project');
			if ( myDate ) {
				setSelectedDate(myDate);
			} else {
				setSelectedDate(DateLocal())
			}
		}
		mydate();
	}, []);

	useEffect(() => {
		setLoading(true);
		setTableHead("");
		// setLines(change);
		// setLoading(false);
		// eslint-disable-next-line
	}, [codProyect, codClassification, codMeans, codType]);

	useEffect(() => {
		setLoading(true);
		dispatch(resetRightInformation());
		if(cardInformationRedux) cardInformationRedux();
		if (tableDetailsRedux) tableDetailsRedux();
		if (tableMeansRedux) tableMeansRedux();
		changeData();
		// eslint-disable-next-line
	}, [codProyect, codClassification, codType, codMeans, selectedDate, tableHead]);

	useEffect(() => {

		changeData();
		// eslint-disable-next-line
	}, [lines]);



	const clickGraphic = (query) => {
		if ( lines ) {
			if (onClickGraphicLines) 
				onClickGraphicLines(tableHead)
		} else {
			if (onClickGraphicBar) 
			onClickGraphicBar(tableHead)
		}
		setLgShow(true);
	};

	const changeData = () => {
		dispatch(resetRightInformationGraphic());
		if (tableHeadRef.current  === '') {
			if (linesRef.current) {
				if ( graphicLinesRedux ) {
					graphicLinesRedux();
					console.log('graphicLinesRedux')
				}
			} else {
				if( graphicBarRedux ) {
					graphicBarRedux();
					console.log('graphicBarRedux')
				}
			}
		} else {
			if (linesRef.current) {
				if (graphicLinesWithHeadRedux ) {
					graphicLinesWithHeadRedux(tableHeadRef.current);
					console.log('graphicLinesWithHeadRedux');
				}
			} else {
				if ( graphicBarWithHeadRedux ) {
					graphicBarWithHeadRedux(tableHeadRef.current);
					console.log('graphicBarWithHeadRedux');
				}
			}
		}
	}

	const changeTitle = (title) => {
		const newTitle = (tableHeadRef.current  === title ? "" : title);
		onSelectTableTitle(newTitle);
		setTableHead(newTitle);
		if(onChangeTitle) onChangeTitle(newTitle)
	}


	useEffect(() => {
		if ( 
				( !graphicLinesRedux || proyects.graphic !== null ) 
			&& (!cardInformationRedux || proyects.DataPc !== null )
			&& (!tableDetailsRedux || proyects.projectDetails !== null)
			&& (!tableMeansRedux || proyects.meansTable !== null)
			) {
			setLoading(false);
		}
		setDataCard(proyects.DataPc && proyects.DataPc[0]);
	}, [proyects.graphic, proyects.DataPc, proyects.projectDetails, proyects.meansTable])

	const formatCardNumber = (key) => {
		const data = proyects.DataPc  && proyects.DataPc[0] 
					? proyects.DataPc[0]
					: {};
		return data[key] !== undefined
			? Intl.NumberFormat("en").format(
				data[key] ?? 0
			)
			: '-'
	}
	const formatCardPorcent = (key) => {
		const data = proyects.DataPc  && proyects.DataPc[0] 
					? proyects.DataPc[0]
					: {};
		return data[key] !== undefined && data[key] !== null
			? `${data[key]}%`
			: '-'
	}

	return (
		<Container style={{width: '100%', maxWidth: '100%'}}>
			<Row>
				<Card className="w-100 mb-1 mt-2">
					
					<Card.Header className="bg-primary p-0 d-flex align-items-center justify-content-around mb-0">
						<h5 className="mb-0 ml-4">
							{loading 
								? "Cargando..." 
								: proyects.DataPc !== null 
									? (cardTitle ? cardTitle : "")
									: "No hay datos" }
						</h5>

						<h5 className="mb-0 ml-5">
							{( changeDate 
								? <KeyboardDatePicker
									variant="inline"
									// onMonthChange={() => setOpenCalendar(false)}
									onOpen={() => setOpenCalendar(true)}
									onClose={() => setOpenCalendar(false)}
									invalidDateMessage={false}
									open={openCalendar}
									views={["year", "month"]}
									minDate={dataCard?.FechaInicioReal}
									maxDate={dataCard?.FechaFinReal}
									format="MMM/yyyy"
									value={auth.dateSelected ? auth.dateSelected : localStorage.getItem('date-project')}
									// InputAdornmentProps={{ position: "start" }}
									onChange={handleDateChange}
								/>
								: <Moment format="MMM/yyyy">{dateProject}</Moment>
							)}
						</h5>
					</Card.Header>
					
					<Card.Body className="p-1">
						<div className="d-flex justify-content-around">
							<Card.Text className="mb-1">
								Monto{" "}
								{formatCardNumber('MontoContrato')}
							</Card.Text>

							<Card.Text className="mb-1">
								{ dataCard?.FechaInicio || dataCard?.FechaInicioReal
									? <Moment format="DD/MM/YYYY">
										{(dataCard?.FechaInicio || dataCard?.FechaInicioReal)}
									</Moment>
									: ""
								}
								{" - "}
								{ dataCard?.FechaFinal || dataCard?.FechaFinReal
									? <Moment format="DD/MM/YYYY">
										{(dataCard?.FechaFinal || dataCard?.FechaFinReal)}
									</Moment>
									: ""
								}
							</Card.Text>

							<Card.Text
								style={{fontSize: 12}}
								className="text-primary mb-2"
							>
								({dataCard?.ReporteA ?? '-'})
							</Card.Text>
						</div>

						<div className="d-flex justify-content-around">
							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-blue card-h5 mr-2 d-flex"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Programado
								</div>
								<p className="mb-1 text-right">
									{" "}
									{formatCardNumber('Programado')}
								</p>
								<p className="mb-1 text-right">
									{" "}
									{formatCardPorcent('PorcentajeProgramado')}
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-yellow card-h5 mr-2 "
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Valorizado
								</div>
								<p
									className={`mb-1 text-right text-right ${
										dataCard?.PorcentajeFA < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{formatCardNumber('Valorizado')}
								</p>
								<p
									className={`mb-1 text-right text-right ${
										dataCard?.PorcentajeFA < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{formatCardPorcent('PorcentajeValorizado')}
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-aqua card-h5 mr-2"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Real
								</div>
								<p
									className={`mb-1 text-right ${
										dataCard?.PorcentajeFC < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{formatCardNumber('Real')}
								</p>
								<p
									className={`mb-1 text-right ${
										dataCard?.PorcentajeFC < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{formatCardPorcent('PorcentajeReal')}
								</p>
							</div>

							<div>
								<h5 className="card-h5">Fa</h5>
								<p
									className={`mb-1 text-right ${
										dataCard?.PorcentajeFA < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{" "}
									{formatCardNumber('FA')}
								</p>
								<p
									className={`mb-1 text-right ${
										dataCard?.PorcentajeFA < 0
											? "text-danger"
											: "text-success"
									}`}
								>
									{formatCardPorcent('PorcentajeFA')}
								</p>
							</div>

							<div>
								<h5>Fc</h5>
								<p
									className={`mb-1 text-right ${
										dataCard?.PorcentajeFC < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{" "}
									{formatCardNumber('FC')}
								</p>
								<p
									className={`mb-1 ${
										dataCard?.PorcentajeFC < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{formatCardPorcent('PorcentajeFC')}
								</p>
							</div>
						</div>

						<div className="w-100">
							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-blue"
											style={{
												width: `${dataCard?.PorcentajeProgramado ?? 0}%`,
											}}
										></div>
									</div>
								</div>

								<div  style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{formatCardPorcent('PorcentajeProgramado')}
									</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-yellow"
											style={{
												width: `${dataCard?.PorcentajeValorizado ?? 0}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{" "}
										{formatCardPorcent('PorcentajeValorizado')}
									</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-aqua"
											style={{
												width: `${dataCard?.PorcentajeReal ?? 0}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b className="porcentaje-barra">
										{" "}
										{formatCardPorcent('PorcentajeReal')}
									</b>
								</div>
							</div>
						</div>
					</Card.Body>
				
				</Card>
			</Row>
			<Modal
				size="lg"
				show={lgShow}
				onHide={() => setLgShow(false)}
				aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header className="text-center" closeButton>
					<div className="w-100">
						<h4 className="text-center">
							RO {tableHead ? `- ${tableHead}` : null} Período y
							Acumulado (S/.)
						</h4>
					</div>
				</Modal.Header>
				<Modal.Body>
					<CardsHistory head={tableHead}/>
				</Modal.Body>
			</Modal>

			{!loading && proyects.graphic && proyects.graphic[0] ? (
				<>
					<Link
						to="#"
						onClick={clickGraphic}
					>
						{ lines 
							? <Line
								data={proyects.graphic}
								className="responsive-chart"
							/>
							: <Bar
								data={proyects.graphic}
								className="responsive-chart"
							/>
						}
					</Link>
				</>
			) : (
				<Line className="responsive-chart" data={[]} />
			)}
			{ tableDetailsRedux 
			? (!loading && proyects.projectDetails && proyects.projectDetails[0] ? (
				<>
					<Table
						striped
						bordered
						hover
						size="sm"
						className="mt-3 bg-white"
					>
						<thead>
							<tr>
								<th className="d-flex justify-content-around headTable">
									<span
										className={linesRef.current && "chartIcon"}
										onClick={() => setLines(true)}
									>
										<i className="fas fa-chart-area"></i>
									</span>
									<span
										className={ !linesRef.current && "chartIcon"}
										onClick={() =>
											setLines(false)
										}
									>
										<i className="far fa-chart-bar"></i>
									</span>
								</th>
								<th
									className="change-chart"
									style={{
										background: `${
											tableHead === "HH"
												? "#d8d8d8"
												: "none"
										}`,
									}}
									onClick={() => changeTitle("HH")}
								>
									HH
								</th>
								<th
									className="change-chart"
									style={{
										background: `${
											tableHead === "MO"
												? "#d8d8d8"
												: "none"
										}`,
									}}
									onClick={() => changeTitle("MO")}
								>
									MO (S/.)
								</th>

								<th
									className="change-chart"
									style={{
										background: `${
											tableHead === "MT"
												? "#d8d8d8"
												: "none"
										}`,
									}}
									onClick={() => changeTitle("MT")}
								>
									MT (S/.)
								</th>

								<th
									className="change-chart"
									style={{
										background: `${
											tableHead === "EQ"
												? "#d8d8d8"
												: "none"
										}`,
									}}
									onClick={() => changeTitle("EQ")}
								>
									EQ (S/.)
								</th>
								<th
									className="change-chart"
									style={{
										background: `${
											tableHead === "SC"
												? "#d8d8d8"
												: "none"
										}`,
									}}
									onClick={() => changeTitle("SC")}
								>
									SC (S/.)
								</th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-blue mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Programado
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HH_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_MT_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HM_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_SC_Programado
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-yellow mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Valorizado
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HH_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_MT_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HM_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_SC_Valorizado
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-aqua mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Real
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_HH_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_MT_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_HM_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_SC_Real
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									Diferencia (V-R)
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_HH < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Diferencia_HH
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_MT < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_HH
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_MT < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_MT
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_HM < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_HM
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_SC < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_SC
									)}
								</td>
							</tr>
						</tbody>
					</Table>
				</>
			) : loading ? (
				"Cargando..."
			) : (
				"Sin datos"
			))
			: <></>}

			{ tableMeansRedux 
			? (!loading && proyects.meansTable ? (
				<>
					<Table
						striped
						bordered
						hover
						width="100%"
						responsive
						size="sm"
						className="mt-3 bg-white"
					>
						<thead>
							<tr>
								<th className="d-flex justify-content-around">
									Insumo
									<div className="headTable">
										<span
											style={{marginRight: '15px'}}
											className={linesRef.current && "chartIcon"}
											onClick={() => setLines(true)}
										>
											<i className="fas fa-chart-area"></i>
										</span>
										<span
											className={!linesRef.current && "chartIcon"}
											onClick={() =>
												setLines(false)
											}
										>
											<i className="fas fa-chart-bar"></i>
										</span>
									</div>
								</th>
								<th>Unidad</th>
								<th>Presupuesto</th>
								<th>Programado</th>
								<th>Valorizado</th>
								<th>Real</th>
							</tr>
						</thead>

						<tbody>
							{proyects.meansTable.map((items) => (
								<tr key={items.CodInsumo}>
									<td className="text-capitalize fs-5">
										{items.DesInsumo}
									</td>
									<td className="text-right">{items.Unidad}</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.PresupuestoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.ProgramadoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.ValorizadoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.RealParcial
										)}
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</>
			) : loading ? (
				"Cargando..."
			) : (
				"Sin datos"
			))
			: <></>}

		</Container>
	);
};

export default ControlParty;
